export const IconBottomRight = (
  <svg fill="none" height="13" viewBox="0 0 12 13" width="12" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.5 12C2.5 12.2761 2.27614 12.5 2 12.5C1.72386 12.5 1.5 12.2761 1.5 12H2.5ZM2 6H1.5C1.5 5.72386 1.72386 5.5 2 5.5V6ZM10.3536 5.64645C10.5488 5.84171 10.5488 6.15829 10.3536 6.35355L7.17157 9.53553C6.97631 9.7308 6.65973 9.7308 6.46447 9.53553C6.2692 9.34027 6.2692 9.02369 6.46447 8.82843L9.29289 6L6.46447 3.17157C6.2692 2.97631 6.2692 2.65973 6.46447 2.46447C6.65973 2.2692 6.97631 2.2692 7.17157 2.46447L10.3536 5.64645ZM1.5 12V6H2.5V12H1.5ZM2 5.5H10V6.5H2V5.5Z"
      fill="currentColor"
    />
  </svg>
);
